import * as yup from 'yup';
import { merge } from 'lodash-es';

export function fundMetricsV2Fields() {
  return {
    fundmapId: yup.string().required().label('Fund Map ID').default(''),
    fundId: yup.number().required().label('Fund ID').default(0),
    date: yup.string().required().label('Date').default(''),
    investmentAmount: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('Investment Amount')
      .default(null),
    distributions: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('Distributions')
      .default(null),
    currentValue: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('Current Value')
      .default(null),
    expenses: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('Expenses')
      .default(null),
    managementFee: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('Management Fee')
      .default(null),
    lpContributions: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('LP Contributions')
      .default(null),
    lpDistributions: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('LP Distributions')
      .default(null),
    gpContributions: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('GP Contributions')
      .default(null),
    gpDistributions: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('GP Distributions')
      .default(null),
    gpCarry: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('GP Carry')
      .default(null),
    netAssets: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('Net Assets')
      .default(null),
    realizedValue: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('Realized Value')
      .default(null),
    initialInvestmentAmount: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('Initial Investment Amount')
      .default(null),
    escrowReceivable: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('Escrow Receivable')
      .default(null),
    professionalFees: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('Professional Fees')
      .default(null),
    generalAndAdministrativeFees: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('General & Administrative Fees')
      .default(null),
    organizationFees: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('Organization Fees')
      .default(null),
    interestExpense: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('Interest Expense')
      .default(null),
    gpTaxDistribution: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('GP Tax Distribution')
      .default(null),
    syndicationCosts: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('Syndication Costs')
      .default(null),
    nii: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('NII')
      .default(null),
    noi: yup
      .number()
      .customMeta({
        formatter: 'currency',
      })
      .nullable()
      .label('NOI')
      .default(null),
    activationDate: yup.string().nullable().label('Activation Date').default(null),
  };
}

export function fundMetricsV2FormSchema() {
  return yup.object().shape(fundMetricsV2Fields());
}

export type FundMetricsV2 = yup.InferType<ReturnType<typeof fundMetricsV2FormSchema>>;

export function createFundMetricsV2(overrides: Partial<FundMetricsV2> = {}): FundMetricsV2 {
  return merge({}, fundMetricsV2FormSchema().getDefault(), overrides);
}
